/**
 * InputSearch Component - Component Definition
 * ============================================
 */

import angular, { IModule, IComponentOptions } from 'angular';

import { InputSearchController } from './controller';
import { INPUT_SEARCH_TEMPLATE } from './template';
import { SIZES, BASE_CLASSES, ICONS, DEFAULTS, InputSearchSize } from './constants';

export interface IInputSearchComponentBindings {
  placeholder?: string;
  showFilter?: boolean;
  disabled?: boolean;
  size?: InputSearchSize;
  ariaLabel?: string;
  onSearch?: (args: { value: string }) => void;
  onClear?: () => void;
  onFilter?: () => void;
}

export const inputSearchComponentDefinition: IComponentOptions = {
  template: INPUT_SEARCH_TEMPLATE,
  controller: InputSearchController,
  require: { ngModelCtrl: '?ngModel' },
  // Slots nombrados: <ec-label>/<ec-help> — capacidad nueva, sin bindings.
  transclude: { labelSlot: '?ecLabel', helpSlot: '?ecHelp' },
  bindings: {
    placeholder: '@',
    showFilter: '<',
    disabled: '<',
    size: '@',
    ariaLabel: '@',
    onSearch: '&?',
    onClear: '&?',
    onFilter: '&?'
  }
};

export const MODULE_NAME = 'ec.inputSearch';

const inputSearchModule: IModule = angular
  .module(MODULE_NAME, ['ngSanitize'])
  .component('ecInputSearch', inputSearchComponentDefinition);

export { InputSearchController, INPUT_SEARCH_TEMPLATE, SIZES, BASE_CLASSES, ICONS, DEFAULTS };
export type { InputSearchSize } from './constants';
export default inputSearchModule;
